import { useFormContext } from "react-hook-form";

import type { TiptapFormValues } from "@/react/components/CommentsCompass/types";

export const useTiptapBody = () => {
  const { setValue, getValues, watch } = useFormContext<TiptapFormValues>();

  const body = watch("tiptap_body.body");
  const sgidMap = watch("tiptap_body.sgids_to_object_map") ?? {};
  const inlineAttachments = watch("tiptap_body.inline_attachments") ?? [];

  const mergeSgidMap = (incoming: Record<string, unknown>) => {
    const current = getValues("tiptap_body.sgids_to_object_map") ?? {};
    setValue("tiptap_body.sgids_to_object_map", { ...current, ...incoming });
  };

  const mergeInlineAttachments = (incoming: unknown[]) => {
    const current = getValues("tiptap_body.inline_attachments") ?? [];
    setValue(
      "tiptap_body.inline_attachments",
      Array.from(new Set([...current, ...incoming])),
    );
  };

  return {
    body,
    sgidMap,
    inlineAttachments,
    mergeSgidMap,
    mergeInlineAttachments,
  };
};
